import propertyPaths from '../paths';
import axios from './axios';
import { ICollateralPropertyLoginResponse } from '../login/types';
import endpoints from './endpoints';

// ----------------------------------------------------------------------

export function jwtDecode(token: string) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
}

// ----------------------------------------------------------------------

export const isValidToken = (accessToken: string) => {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);

  console.log('decoded', decoded);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

// ----------------------------------------------------------------------

export const tokenExpired = (exp: number) => {
  // eslint-disable-next-line prefer-const
  let expiredTimer;

  const currentTime = Date.now();

  // Test token expires after 10s
  // const timeLeft = currentTime + 10000 - currentTime; // ~10s
  const timeLeft = exp * 1000 - currentTime;

  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(() => {
    console.error('Token expired');

    async function refresh() {
      const refreshToken = localStorage.getItem('propertyRefreshToken');
      const accessToken = localStorage.getItem('propertyAccessToken');
      if (refreshToken && accessToken) {
        try {
          const res = await axios.post(
            endpoints.agentNetworkService.auth.refresh
          );
          const resData: ICollateralPropertyLoginResponse = res.data;
          if (
            res.status === 201 &&
            resData.accessToken &&
            resData.refreshToken
          ) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            setSession(resData.accessToken, resData.refreshToken);
          }
        } catch (error) {
          console.error(error);
          localStorage.removeItem('propertyAccessToken');
          localStorage.removeItem('propertyRefreshToken');
          localStorage.removeItem('propertyProfile');

          window.location.href = propertyPaths.login;
        }
      }
    }

    refresh();
  }, timeLeft);
};

// ----------------------------------------------------------------------

export const setSession = (
  accessToken: string | null,
  refreshToken: string | null
) => {
  if (accessToken && refreshToken) {
    localStorage.setItem('propertyAccessToken', accessToken);
    localStorage.setItem('propertyRefreshToken', refreshToken);

    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    axios.defaults.headers.common['Refresh-Token'] = refreshToken;

    // This function below will handle when token is expired
    const { exp } = jwtDecode(accessToken);
    tokenExpired(exp);
  } else {
    localStorage.removeItem('propertyAccessToken');
    localStorage.removeItem('propertyRefreshToken');
    localStorage.removeItem('propertyProfile');

    delete axios.defaults.headers.common.Authorization;
  }
};
